<template>

    <Head title="Perfil" />

    <aside 
      class="fixed w-full duration-500 max-w-[400px] z-30 bg-violet-100 shadow-[0px_0px_30px] shadow-gray-400 top-0 bottom-0 px-4 pt-10 pb-10 overflow-y-auto"
      :class="{ '-right-full': !openFilters, 'right-0': openFilters }">
        <button 
          arial-label="Botão fechar filtros"
          class="w-10 h-10 absolute top-4 right-4 text-gray-500"
          @click="openFilters = false">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x">
              <path d="M18 6 6 18"/>
              <path d="m6 6 12 12"/>
            </svg>
        </button>

        <h3 class="text-base font-bold">Pesquisa</h3>

        <select-input class="w-full mt-3" label="Região">
            <option value="">Selecione a região</option>
        </select-input>

        <select-input class="w-full mt-3" label="Estado">
            <option value="">Selecione o Estado</option>
        </select-input>

        <select-input class="w-full mt-3" label="Cidade">
            <option value="">Selecione o Cidade</option>
        </select-input>

        <div class="flex justify-between gap-4">
          <div class="flex-1">
            <p class="mt-4">Data inicio</p>
            <date-input class="mt-3" />
          </div>

          <div class="flex-1">
            <p class="mt-4">Data final</p>
            <date-input class="mt-3" />
          </div>
        </div>

        <p class="mt-4">Total de promotores</p>
        <div class="flex justify-between gap-4">
          <text-input type="number" min="0" class="mt-3" />
          <text-input type="number" min="1" class="mt-3" />
        </div>

        <div class="flex flex-shrink-0 flex-wrap items-center justify-start rounded-b-md mt-4">
          <button
            class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out ">
              <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
              Pesquisar
          </button>

          <button
            class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase ml-1 border-solid border-2 border-purple-100">
              <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
              Limpar
          </button>
        </div>
    </aside>


    <div class="w-full">
        <div class="w-full lg:flex items-center justify-between">
            <h1 class="text-xl md:text-2xl text-gray-777 font-roboto uppercase">
                Dashboard
            </h1>

            <div class="flex items-center">
                <div class="flex flex-wrap">
                    <outline-button 
                        text="Messes" 
                        @click="changeRangeUnit('month')"
                        :selected="filters.rangeUnit == 'month'" />
                    
                    <outline-button 
                        text="Anos" 
                        @click="changeRangeUnit('year')"
                        :selected="filters.rangeUnit == 'year'" />
                    
                    <outline-button 
                        text="Periodo" 
                        class="mr-10" 
                        @click="changeRangeUnit('day')" 
                        :selected="filters.rangeUnit == 'day'" />

                    <date-range-input 
                        v-model="filters.range" 
                        :month-picker="filters.rangeUnit == 'month'"
                        :year-picker="filters.rangeUnit == 'year'"
                        :interval-picker="filters.rangeUnit == 'day'" />
                </div>

                <button 
                    class="ml-10 btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100"
                    @click="openFilters = true">
                    <font-awesome-icon icon="fa-filter" class="text-purple text-sm mr-0 lg:mr-2" />
                    Filtrar
                </button>
            </div>
        </div>

        <div class="mt-4 flex flex-wrap">
            <purple-panel title="Redes Vinculadas" value="1.586" icon="fa-regular fa-star" />
            <purple-panel title="Promotores Vinculados" value="698" icon="fa-cart-shopping" />
            <purple-panel title="Relatórios enviados" value="5.874" icon="fa-list-check" />
        </div>

        <div class="gap-4 w-full mt-6 lg:flex">
            <div class="w-full bg-white shadow rounded-lg p-4 sm:p-4 xl:p-6">
                <div class="lg:flex items-center justify-between w-full">
                    <select-input v-model="filters.category">
                        <option v-for="(category, index) in categories" :key="index" :value="index">
                            {{ category }}
                        </option>
                    </select-input>
    
                    <p class="text-[#5A607F] my-5 text-center">Últimos 12 meses</p>
    
                    <span />
                </div>

                <line-chart 
                    class="w-full mx-auto lg:w-10/12"
                    :data-options="lineChartOptions" 
                    :key="1" />
            </div>

            <div class="bg-white shadow rounded-lg p-4 sm:p-4 xl:p-6 w-full mt-4 lg:mt-0 lg:max-w-[400px]">
                <p class="text-center">
                    <strong>Status das atividades</strong>
                </p>

                <donut-chart
                    :series="Object.values(dashbordData.statusActivities)" 
                    :labels="Object.keys(dashbordData.statusActivities)" />
            </div>
        </div>
    </div>

</template>

<script>

import { Head } from '@inertiajs/inertia-vue3'
import ProviderLayout from '@/Shared/ProviderLayout.vue'

import OutlineButton from './Components/OutlineButton.vue'

import LineChart from '@/Shared/LineChart'
import PurplePanel from '@/Shared/PurplePanel.vue'
import DonutChart from '@/Shared/DonutChart'
import SelectInput from '@/Shared/SelectInput.vue'
import TextInput from '@/Shared/TextInput.vue'
import DateInput from '@/Shared/DateInput'

import DateRangeInput from '@/Shared/DateRangeInput.vue'

export default {

    layout: ProviderLayout,

    components: {
        Head,
        OutlineButton,
        PurplePanel,
        DonutChart,
        SelectInput,
        LineChart,
        DateInput,
        TextInput,
        DateRangeInput,
    },

    data() {
        return {
            openFilters: false,

            categories: {
                activity: 'Atividades Executadas',
                providers: 'Fornecedores Cadastrados',
                brand: 'Mercados Cadastrados',
                promotersTotal: 'Total de Promotores',
                promotersActivitie: 'Total de promotores ativos',
                marketsActivitie: 'Total de mercados ativos',
                providersActivitie: 'Total de fornecedores ativos',
                repture: 'Total de Rupturas dentro do período',
            },

            lineChartOptions: [
                {
                    label: 'Atividades Executadas ',
                    value: 100,
                },
                {
                    label: 'Fornecedores Cadastrados',
                    value: 150,
                },
                {
                    label: 'Mercados Cadastrados',
                    value: 160,
                },
                {
                    label: 'Total de Promotores',
                    value: 90,
                },
            ],


            filters: {
                category: 'activity',
                rangeUnit: 'month',
                range: {
                    start: '',
                    end: '',
                },
            },

            dashbordData: {
                statusActivities: {
                    seila: 10
                }
            },
        }
    },

    methods: {
        changeRangeUnit(unit) {
            this.filters.rangeUnit = unit
        }
    }

}

</script>
